import { render, staticRenderFns } from "./InvoiceGenerate.vue?vue&type=template&id=2bf81b67"
import script from "./InvoiceGenerate.vue?vue&type=script&lang=js"
export * from "./InvoiceGenerate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports